import { render, staticRenderFns } from "./Body.vue?vue&type=template&id=dd985336&scoped=true"
import script from "./Body.vue?vue&type=script&lang=js"
export * from "./Body.vue?vue&type=script&lang=js"
import style0 from "./Body.vue?vue&type=style&index=0&id=dd985336&prod&lang=scss"
import style1 from "./Body.vue?vue&type=style&index=1&id=dd985336&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dd985336",
  null
  
)

export default component.exports